export const DEFAULT_PROPERTIES = {
    width: 300,
    height: 300,
    fillColor: '#FFFFFF',
    isBorderFilled: true,
    watchFace: 'FACE_1',
    displayTime: new Date(),
    displayConstantTime: false,
    hingeColor: '#333',
    handColor: '#333',
    frameGradientColorList: ['#333', '#FFFFFF', '#333']
}


// WEBPACK FOOTER //
// ./src/defaultProperties.js